export default function scrollToTop() {
    const scrollBtn = document.querySelector('.scroll-to-top');

    if (scrollBtn) {
        scrollBtn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        });
    }
}

scrollToTop();
